import axios from "axios";

export default {
    async getRapportini(userID: string) {
        const data = new FormData();
        data.append("limit", "50");
        data.append("offset", "0");
        data.append("where[]", `rapportini_id IN (SELECT rapportini_id FROM rel_rapportini_users WHERE users_id = ${userID})`);
        data.append("orderby", "rapportini_data");
        data.append("orderdir", "desc");

        const response = await axios.post("rest/v1/search/rapportini", data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });
        //console.log(response.data);
        return response.data;
    },

    /*  async getRapportini(userID: string) {
        const data = new FormData();
        data.append("limit", "50");
        data.append("offset", "0");
        data.append("where[]", `rapportini_id IN (SELECT rapportini_id FROM rel_rapportini_users WHERE users_id = ${userID})`);
        data.append("orderby", "rapportini_data");
        data.append("orderdir", "desc");

        const response = await axios.post("rest/v1/search/rapportini", data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });
        //console.log(response.data);
        return response.data;
    }, */

    /**
     *
     * @param appuntamentoId
     * @returns rapportino creato da me per l'appuntamento in questione
     */
    async getRapportinoAppuntamento(appuntamentoId: string, userID: string) {
        const data = new FormData();
        data.append("where[]", `rapportini_appuntamento_id = ${appuntamentoId}`);
        data.append("where[]", `rapportini_id IN (SELECT rapportini_id FROM rel_rapportini_users WHERE users_id = ${userID})`);

        const response = await axios.post("rest/v1/search/rapportini", data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });
        return response.data;
    },

    async saveRapportino(formData) {
        const response = await axios.post("rest/v1/create/rapportini", formData, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });
        //console.log(response.data.data);
        return response;
    },

    async editRapportino(formData, rapportino_id) {
        const response = await axios.post(`rest/v1/edit/rapportini/${rapportino_id}`, formData, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });
        //console.log(response.data.data);
        return response;
    },

    async getCategorieFoto() {
        const response = await axios.get("rest/v1/search/rapportini_immagini_categoria", {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });
        //console.log(response);
        return response;
    },

    async salvaFotoRapportino(immagini, rapportino) {
        const data = new FormData();
        data.append("rapportino_id", rapportino);
        data.append("immagini", JSON.stringify(immagini));

        //const response = await axios.post(`http://192.168.11.183/ingegno_plan/rapportini/rapportini/savePhotos`, data);
        const response = await axios.post(`${process.env.VUE_APP_BASE_URL}rapportini/rapportini/savePhotos`, data);
        //console.log(response);
        return response;
    },

    async getImmagini(rapportino: string) {
        const data = new FormData();
        data.append("where[]", `rapportini_immagini_rapportino_id = '${rapportino}'`);

        const response = await axios.post("rest/v1/search/rapportini_immagini", data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });
        return response;
    },
};
